import React from "react";
import { TextField as MuiTextField } from "@mui/material";

export const CustomTextField = React.memo(({ onChange, className, ...props }) => {
  return <MuiTextField onChange={onChange} className={className} {...props} />;
});
